import { Box } from "@mui/material";
import { styled, useTheme } from "@mui/material/styles";

const HighlightEffect = styled("span")(({ color }) => ({
  background: `linear-gradient(
      180deg,
      rgba(255, 255, 255, 0) 50%,
      ${color} 50%
    )`,
}));

const Highlight = ({ children, color }) => {
  return (
    <HighlightEffect className="title" color={color}>
      {children}
    </HighlightEffect>
  );
};

export const HighlightTitle = ({ children, ...props }) => {
  const theme = useTheme();

  return (
    <Box
      sx={{
        color: theme.palette_custom.darkBlue,
        fontWeight: theme.fontWeight[400],
        fontSize: theme.fontSize.md,
        width: "100%",
      }}
      {...props}
    >
      {children}
    </Box>
  );
};

export default Highlight;
